module.exports = __webpack_public_path__ + "img/hohlschnitt_gruen_candy.49f7c79d.jpg";